import React from "react"
import { IConditionCheckboxPanel } from "./IConditionCheckboxPanel"

export enum FormElementType {
    SHORT_TEXT = "Short Text",
    LONG_TEXT = "Long Text",
    DROPDOWN = "Dropdown",
    USER_SELECT = "User Select",
    CHECKBOX = "Checkbox",
    IMAGE_SELECT = "Image Select",
    VIDEO_SELECT = "Video Select",
    FILE_SELECT = "File Select",
    SUBMIT_BUTTON = "Submit Button",
    CHOICE_BUTTON = "Choice Button",
    VIEW_FORM_BUTTON = "View Form Button"
}

export type IFormButtonElement = FormElementType.VIEW_FORM_BUTTON | FormElementType.SUBMIT_BUTTON 

export enum ValidationRules {
    TITLE_IS_REQUIRED = 'titleIsRequired',
    RULES_ARE_INVALID = 'rulesAreInvalid',
    DROPDOWN_REQUIRES_OPTIONSETS = 'dropDownRequiresOptionSets',
    MUST_HAVE_AT_LEAST_1_OPTION = 'mustHaveAtLeastOneOption',
    OPTIONS_MUST_HAVE_LABEL_TEXT = 'optionsMustHaveLabelText',
    CONDITIONAL_EXPRESSION_IS_INVALID = 'condtionalExpressionIsInvalid'
}

export interface IElementTypeInformation {
    className?: string,
    elementType: FormElementType,
    withBrackets?: boolean
}

export interface IMinimisedElement {
    elementType: FormElementType,
    labelText: string,
    isRequiredElement: boolean,
    onDeleteElementClick: ()=>void,
    onEditElementClick: ()=>void,
    validationErrors?: ValidationRules[],
    dragRef:any
}

export interface IEditFormElementWidget {
    formElementId: number,
    isRequiredElement: boolean,
    elementType: FormElementType,
    labelText: string,
    setLabelText: (labelText: string) => void,
    formElementComponent: any,
    isFirstElement: boolean,
    isLastElement: boolean,
    onMoveElementUp: any,
    onMoveElementDown: any,
    rulesComponent: React.JSX.Element
    onDeleteElementClick: () => void,
    onSaveClick: () => void
    conditionalCheckboxPanel?: React.JSX.Element
    advancedOptions?: React.JSX.Element
    validationErrors?: ValidationRules[]
}


export interface IFormElementWidget {
    formElementId: number, 
    isRequiredElement: boolean,
    elementType: FormElementType,
    labelText: string,
    setLabelText: (labelText: string) => void,
    onSaveClick: () => void,
    onDeleteElementClick: ()=>void,
    onDragElementClick: (currentItemId: number, targetItemId: number)=>void,
    formElementComponent: any,
    isFirstElement: boolean,
    isLastElement: boolean,
    onMoveElementUp: any,
    onMoveElementDown:any,
    isEditModeOpen: boolean,
    setIsEditModeOpen?: () => void,
    rulesComponent: React.JSX.Element
    conditionalCheckboxPanel?: React.JSX.Element
    advancedOptions?: React.JSX.Element
    validationErrors?: ValidationRules[],
    index: number
}

export interface IFormElementList {
    formSubmitText: string,
    setFormSubmitText: (text: string)=>void,
    onAddFormOptionClick: any
    formElements: IFormElementWidget[]
}